import React from 'react'

const TenantTableHead = () => {
    return (
        <thead className="TableHead SettingItem">
        <tr>
            <th className="leadName">Tenant</th>
            <th className="leadName">Tham số</th>
            <th className="fieldTitle">Giá trị</th>
            <th className="leadName">Tiêu đề</th>
            <th className="leadName">Trạng thái</th>
            <th className="Actions text-center">Action</th>
        </tr>
        </thead>
    )
}

export default TenantTableHead